import axios from "axios"

/** What the `/input/*` endpoints resolve a social account's creds from. */
export type InputCredHandle = { scID: number } | { inputId: number } | { credID: string }

/**
 * Which handle identifies a social input's account for `/input/preview`: a
 * reused SocialCred, then the incomplete input
 * an OAuth return hands back holding the new creds (`AuthModule`), then that
 * OAuth session itself. Null when the input carries none of them.
 */
export function inputCredHandle(input: {
  scID?: number | string | null
  inputId?: number | string | null
  credID?: number | string | null
}): InputCredHandle | null {
  if (input.scID) return { scID: parseInt(String(input.scID), 10) }
  if (input.inputId) return { inputId: parseInt(String(input.inputId), 10) }
  if (input.credID) return { credID: String(input.credID) }

  return null
}

/** POSTs to one of the `/input/*` endpoints and resolves the decoded body. */
export async function postInputEndpoint(
  apiUrl: string,
  endpoint: string,
  data: Record<string, unknown>
): Promise<unknown> {
  const response = await axios({
    url: `${apiUrl}/input/${endpoint}`,
    data,
    headers: { "Content-type": "application/json" },
    method: "POST",
    withCredentials: true,
    responseType: "json",
  })

  return response.data
}
